import { React, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import axios from 'axios';
import Swal from 'sweetalert2';

import { getCertificateName } from '../../constants/certificates';
import { usePaymentByCode } from '../../hooks/usePaymentByCode';
import { usePaymentMethods } from '../../hooks/usePaymentMethods';
import { SAMPLE_PRODUCT_TYPE } from '../../hooks/useSampleProducts';
import { useBooks } from '../../hooks/useBooks';
import { useModal } from '../../providers/ModalProvider';
import { cartPaths, orderPlacedPaths } from '../../providers/TranslatedSlugProvider';
import { formatPriceForView as localFormatPrice } from '../../utils/format';
import { useLoader } from '../../utils/hooks';
import { getTranslated } from '../../utils/translations';
import User from '../../utils/user';
import CertificateIcon from '../product/Components/CertificateIcon/CertificateIcon';
import ProductImage from '../product/Components/ProductImage';
import { CUSTOM_PRODUCT_IMAGE_SRC } from '../product/custom_product';

import CheckoutPurchase from './components/CheckoutPurchase';
import PSample from './components/PSample';
import PBook from './components/PBook';
//import state from 'sweetalert/typings/modules/state';


const Checkout = (props) => {
  const [totalForProducts, setTotalForProducts] = useState(0);
  const [totalSupplement, setTotalSupplement] = useState(0);
  const [details, Setdetails] = useState({});
  const [user, SetUser] = useState([]);
  const [SalesTable, SetSalesTable] = useState([]);
  const [address, Setaddress] = useState(0);
  const [FIL_LOGISTICSADDRESSZONEID, SetFIL_LOGISTICSADDRESSZONEID] = useState(0);
  const [Shipping_method, SetShipping_method] = useState(0);
  const [shipping_option, Setshipping_option] = useState('single');
  const [availableShippingOptionList, setAvailableShippingOptionList] = useState([{ type: 'single', idOnFrontEnd: 1 }]);
  const [shipping_, Setshipping] = useState(0);
  const [Payment_method, SetPayment_method] = useState(0);
  const [referent, setReferent] = useState('');
  const [notes, Setnote] = useState('');
  const [attemptedSubmitWithoutReferent, setAttemptedSubmitWithoutReferent] = useState(false);
  const dataUser = useSelector((state) => state?.auth?.userDataDetail);
  const agentDataDetail = useSelector((state) => state?.auth?.agentDataDetail);
  const { t, i18n } = useTranslation();
  const detailsLoader = useLoader({ height: '80vh' });
  const [userShipCarrierAccount, setUserShipCarrierAccount] = useState('');
  const [shipCarrierAccount, setShipCarrierAccount] = useState('');
  const [spedizione_esente, setSpedizione_esente] = useState('');
  const { paymentMethods, paymentTerms } = usePaymentMethods({});
  const { books } = useBooks({ autoLoad: true });



  const { payment, paymentTerm } = usePaymentByCode({
    paymentMethods,
    paymentCode: dataUser.PAYMMODE,
    paymentTerms,
    paymentTermCode: dataUser.PAYMTERMID,
  });


  const addresses = details?.addresses || [];
  const formatPriceForView = (amount) => localFormatPrice(amount, User.getCurrency(dataUser));

  const hasAtLeastOneOnDemand = useMemo(() => {
    let result = false;
    if (details?.carts?.find) {
      result = !!details.carts.find((cart) => {
        let parsed = JSON.parse(cart?.is_available_json);
        return parsed?.available === 'on demand';
      });
    }
    return result;
  }, [details?.carts]);

  useEffect(() => {
    let isAlreadyAdded = !!availableShippingOptionList.find((i) => i.type === 'multiple');

    if (details?.carts?.length > 1 && hasAtLeastOneOnDemand && !isAlreadyAdded) {
      setAvailableShippingOptionList((s) => [...s, { type: 'multiple', idOnFrontEnd: 2 }]);
      Setshipping_option('single');
    }
  }, [hasAtLeastOneOnDemand, details?.carts]);
  //const userId = dataUser.parent_id ? dataUser.parent_id : dataUser.id
  const list = (id) => {
    detailsLoader.watchPromise(
      axios.get('/v1/checkout-page?client_id=' + dataUser.id + '&parent_id=' + dataUser.parent_id + '').then((response) => {
        Setdetails(response.data.result.data);
        setTotalSupplement(
          (response.data.result.data?.carts || []).reduce((acc, item) => {
            const parsedData = JSON.parse(item.is_available_json);
            let supplimentValue = 0;

            if (Array.isArray(parsedData?.suppliment)) {
              supplimentValue = parseFloat(parsedData.suppliment[0]) || 0;
            } else if (typeof parsedData?.suppliment === 'number') {
              supplimentValue = parsedData.suppliment;
            } else if (typeof parsedData?.suppliment === 'string') {
              supplimentValue = parseFloat(parsedData.suppliment) || 0;
            }

            return acc + supplimentValue;
          }, 0)
        );
        setTotalForProducts(
          (response.data.result.data?.carts || []).reduce((acc, item) => {
            return (
              acc +
              ((parseFloat(item.product_price) + (JSON.parse(item.is_available_json)?.suppliment2 || 0)) *
                item.quantity || 0)
            );
          }, 0)
        );
      })
    );
  };
  const modal = useModal();

  const isSampleOrder = useMemo(() => {
    return details?.carts?.every((item) => item.product_type === SAMPLE_PRODUCT_TYPE);
  }, [details, SAMPLE_PRODUCT_TYPE]);

  const addTableDlvAddr = (tableName, data) => {
    data.append(`${tableName}[0][TableDlvAddr][0][Address]`, '');

    let selectedAddress = details.addresses.find((i) => i.id === address);

    if (selectedAddress) {
      data.append(`${tableName}[0][TableDlvAddr][0][Address]`, selectedAddress.ADDRESS);
      data.append(`${tableName}[0][TableDlvAddr][0][LocationName]`, selectedAddress.ADDRESSNAME);
      data.append(`${tableName}[0][TableDlvAddr][0][Street]`, selectedAddress.STREET);
      data.append(`${tableName}[0][TableDlvAddr][0][ZipCode]`, selectedAddress.ZIPCODE);
      data.append(`${tableName}[0][TableDlvAddr][0][City]`, selectedAddress.CITY);
      data.append(`${tableName}[0][TableDlvAddr][0][CountryRegionId]`, selectedAddress.COUNTRYREGIONID);
      // data.append(`${tableName}[0][TableDlvAddr][0][Location]`, selectedAddress.LOCATIONID);
    }
    if (selectedAddress.COUNTRYREGIONID === 'ITA') {
      data.append(`${tableName}[0][TableDlvAddr][0][County]`, selectedAddress.COUNTY);
      data.append(`${tableName}[0][TableDlvAddr][0][State]`, dataUser.province || '');
    }
    else {
      data.append(`${tableName}[0][TableDlvAddr][0][State]`, '');
    }

    return data;
  };

  const addNotes = (tableName, data) => {
    if (notes) {
      data.append(`${tableName}[0][DocuRefHeader][0][Name]`, 'Nota ordine');
      data.append(`${tableName}[0][DocuRefHeader][0][Notes]`, notes);
      data.append(`${tableName}[0][DocuRefHeader][0][TypdeId]`, 'nota');
    }

    return data;
  };

  const buildSampleOrderBody = () => {
    let data = new FormData();
    const formattedDate = new Date().toISOString().slice(0, 16);
    data.append('FILSamplingOrder[0][FILSamplingAccountType]', 'Prospect');
    data.append('FILSamplingOrder[0][FILSamplingCausalCode]', 'WEB');
    data.append('FILSamplingOrder[0][FILSamplingCustomerRef]', referent);
    data.append('FILSamplingOrder[0][FILSamplingOrderDate]', formattedDate);
    data.append('FILSamplingOrder[0][FILSamplingOrderDateSpecified]', true);
    data = addTableDlvAddr('FILSamplingOrder', data);
    data = addNotes('FILSamplingOrder', data);

    details.carts.map((item, index) => {
      const is_available_json = JSON.parse(item.is_available_json);
      data.append(
        'FILSamplingOrder[0][FILSamplingOrderTrans][' + index + '][FILSamplingItemId]',
        is_available_json?.sample?.subProduct?.codice_sub_sample ?? is_available_json?.sample?.codice_sample
      );
      data.append('FILSamplingOrder[0][FILSamplingOrderTrans][' + index + '][FILSamplingLineNum]', 1);
      data.append('FILSamplingOrder[0][FILSamplingOrderTrans][' + index + '][FILSamplingLineNumSpecified]', true);
      data.append('FILSamplingOrder[0][FILSamplingOrderTrans][' + index + '][FILSamplingQty]', item.quantity);
      data.append('FILSamplingOrder[0][FILSamplingOrderTrans][' + index + '][FILSamplingQtySpecified]', true);
      data.append('FILSamplingOrder[0][FILSamplingOrderTrans][' + index + '][FILSamplingUnit]', 'kg');
      data.append('FILSamplingOrder[0][FILSamplingOrderTrans][' + index + '][InventDim][0][ConfigId]', item.config_id);
      data.append('FILSamplingOrder[0][FILSamplingOrderTrans][' + index + '][InventDim][0][InventColorId]', 'AM004');
      data.append('FILSamplingOrder[0][FILSamplingOrderTrans][' + index + '][InventDim][0][InventSiteId]', 'FILM');
    });
    
    data.append('referent', referent);
    /*for (let pair of data.entries()) {
      console.log(`${pair[0]}: ${pair[1]}`);
    }*/
    

    return data;
  };

  const buildStandardOrderBody = () => {
    let data = new FormData();

    const formattedDate = new Date().toISOString().slice(0, 16);

    data.append('client_id', dataUser.id);
    data.append('customerid', dataUser.ACCOUNTNUM);
    data.append('SalesTableArray[0][CurrencyCode]', dataUser.CURRENCY);
    data.append('SalesTableArray[0][CustAccount]', dataUser.ACCOUNTNUM);
    data.append('SalesTableArray[0][DeliveryDate]', formattedDate);
    data.append('SalesTableArray[0][DeliveryDateSpecified]', true);
    data.append('SalesTableArray[0][DlvTerm]', dataUser.DLVTERM);
    data.append('SalesTableArray[0][FIL_OrderType]', 'WEB');
    data.append('SalesTableArray[0][PaymMode]', dataUser.PAYMMODE);
    data.append('SalesTableArray[0][MCROrderStoppedSpecified]', true);
    data.append('SalesTableArray[0][PurchOrderFormNum]', 'WEB');
    data.append('SalesTableArray[0][ReceiptDateRequested]', formattedDate);
    data.append('SalesTableArray[0][FIL_LogisticsAddressZoneId]', FIL_LOGISTICSADDRESSZONEID);
    data.append('SalesTableArray[0][SalesType]', 3);
    data.append('SalesTableArray[0][SalesTypeSpecified]', true);
    data.append('SalesTableArray[0][ShipCarrierAccount]', shipCarrierAccount);
    data.append('SalesTableArray[0][DlvReason]', 'VEN');

    // Aggiunta del campo spedizione basato sul metodo di spedizione selezionato
    let spedizioneValue = '';
    if (Shipping_method === 1) {
      spedizioneValue = 'Spedizione tramite vettore Filmar';
    } else if (Shipping_method === 2) {
      spedizioneValue = 'Ritiro tramite proprio vettore';
    } else if (Shipping_method === 3) {
      spedizioneValue = 'Costo Spedizione esente';
    }
    data.append('spedizione', spedizioneValue);
    data.append('shipping_cost', shipping_);

    data = addTableDlvAddr('SalesTableArray', data);
    data = addNotes('SalesTableArray', data);

    if (agentDataDetail?.id) {
      data.append('SalesTableArray[0][SalesOriginId]', agentDataDetail?.ACCOUNTNUM === 'Filmar' ? 'Filmar' : 'Agente');
    }

    if (shipping_option === 'single') {
      data.append('SalesTableArray[0][PickComplete_CGK_2014Specified]', true);
      data.append('SalesTableArray[0][PickComplete_CGK_2014]', 'yes');
    }

    const result = details?.carts?.find((item) => parseFloat(item?.precise_integer) >= 1);
    if (result) {
      data.append('SalesTableArray[0][SalesOrderGroup_CGK_2014]', true);
      data.append('SalesTableArray[0][PreciseCones_CGK_2014]', 'yes');
    }

    //  [
    //   "Address" => 'same field of user_adresses table on db',
    //   "County" => "same field of user_adresses table on db",
    //   "LocationName" => "ADDRESSNAME field of user_adresses table on db"
    //   "Street" => "same field of user_adresses table on db"
    //   "ZipCode" =>"same field of user_adresses table on db"
    //   "City" => "same field of user_adresses table on db"
    //   "CountryRegionId" =>"same field of user_adresses table on db"
    //   "Location" => "same field of user_adresses table on db"
    // ]);

    // let preciseCones = 1;

    details?.carts?.map((item, index) => {
      const id = JSON.parse(item.is_available_json)?.ItemId;
      let suppliment = JSON.parse(item.is_available_json)?.suppliment;

      let gestione_spese_get = JSON.parse(item.is_available_json)?.gestione_spese;
      let gestione_spese_ready = 'GEST';

      //console.log('gestione_spese_get',gestione_spese_get);
      if (gestione_spese_get === 0 || gestione_spese_get === 2) {
        gestione_spese_ready = 'GEST'; //STOCK
      } else if (gestione_spese_get === 1) {
        gestione_spese_ready = 'GESTLH100';  //LEAN
      }
      //console.log('get certificate',getCertificateName());
      // if (parseFloat(item?.precise_integer) >= 1 && preciseCones) {
      //   preciseCones = 0;
      //   data.append('SalesTableArray[0][SalesOrderGroup_CGK_2014]', true);
      //   data.append('SalesTableArray[0][PreciseCones_CGK_2014]', 'yes');
      // }

      const number = user.find((o) => o.qty >= parseFloat(item.quantity))?.randomNumber || 3;
      
      // Per i prodotti personalizzati, usa custom_product_name da is_available_json
      let productName = item.product_name;
      if (item.is_custom_product) {
        const parsedJson = JSON.parse(item.is_available_json || '{}');
        productName = parsedJson.custom_product_name || item.product_name;
      }
      
      data.append('SalesTableArray[0][SalesLine][' + index + '][ItemId]', id || 'FI30/100074S550407');
      data.append('SalesTableArray[0][SalesLine][' + index + '][Name]', productName);
      data.append('SalesTableArray[0][SalesLine][' + index + '][LineNum]', index + 1);
      data.append('SalesTableArray[0][SalesLine][' + index + '][LineNumSpecified]', true);
      data.append(
        'SalesTableArray[0][SalesLine][' + index + '][SalesPrice]',
        parseFloat(item.product_price) + (JSON.parse(item.is_available_json)?.suppliment2 || 0)
      );
      data.append('SalesTableArray[0][SalesLine][' + index + '][SalesPriceSpecified]', true);
      data.append('SalesTableArray[0][SalesLine][' + index + '][SalesQty]', item.quantity);
      data.append('SalesTableArray[0][SalesLine][' + index + '][SalesUnit]', 'kg');

      if (item.certificate) {
        data.append('SalesTableArray[0][SalesLine][' + index + '][YarntypeId_CGK_7262]', item.certificate);
        data.append('SalesTableArray[0][SalesLine][' + index + '][TCRequest_CGK_7262]', '1');
        data.append('SalesTableArray[0][SalesLine][' + index + '][TCRequest_CGK_7262Specified]', true);
        data.append(
          'SalesTableArray[0][SalesLine][' + index + '][SalesExtraPrice_CGK_23882]',
          JSON.parse(item.is_available_json)?.suppliment2 || 0
        );
        data.append('SalesTableArray[0][SalesLine][' + index + '][SalesExtraPrice_CGK_23882Specified]', true);
      }

      if (Number(dataUser.FILSALESWETNESSCALCEXCLUDE) !== 1) {
        data.append(
          'SalesTableArray[0][SalesLine][' + index + '][FILSalesWetnessPercent]',
          number == 3 ? 3 : number.toFixed(1) + `${parseInt(Math.random() * 10)}`
        );
        data.append('SalesTableArray[0][SalesLine][' + index + '][FILSalesWetnessPercentSpecified]', true);
      }

      data.append('SalesTableArray[0][SalesLine][' + index + '][InventDim][0][ConfigId]', item.config_id);
      data.append('SalesTableArray[0][SalesLine][' + index + '][InventDim][0][InventColorId]', item.color_id);
      data.append('SalesTableArray[0][SalesLine][' + index + '][InventDim][0][FILInventPackingTypeId]', 'RcDrCc1000');
      data.append('SalesTableArray[0][SalesLine][' + index + '][InventDim][0][InventSiteId]', 'FILM');
      if (suppliment || 0) {
        if (Array.isArray(suppliment)) {
          suppliment = suppliment[0];
        } else {
          suppliment = suppliment;
        }
        data.append('SalesTableArray[0][SalesLine][' + index + '][MarkupTransLine][0][Value]', suppliment);
        data.append('SalesTableArray[0][SalesLine][' + index + '][MarkupTransLine][0][ValueSpecified]', true);
        data.append('SalesTableArray[0][SalesLine][' + index + '][MarkupTransLine][0][LineNum]', index + 1);
        data.append('SalesTableArray[0][SalesLine][' + index + '][MarkupTransLine][0][LineNumSpecified]', true);
        data.append('SalesTableArray[0][SalesLine][' + index + '][MarkupTransLine][0][TaxItemGroup]', 'ART');
      }
      if (gestione_spese_ready) {
        data.append('SalesTableArray[0][SalesLine][' + index + '][MarkupTransLine][0][MarkupCode]', gestione_spese_ready);
      }


      let DocuRefLine = [];
      if (parseFloat(item?.precise_integer) >= 1) {
        // DocuRefLine.push({
        //   name: 'Richiesta Rocche precise',
        //   notes: 'richiesto nr.' + item?.precise_integer,
        //   typdeId: 'nota',
        // });
      }

      DocuRefLine.map((item, drli) => {
        data.append('SalesTableArray[0][SalesLine][' + index + '][DocuRefLine][' + drli + '][Name]', item.name);
        data.append('SalesTableArray[0][SalesLine][' + index + '][DocuRefLine][' + drli + '][Notes]', item.notes);
        data.append('SalesTableArray[0][SalesLine][' + index + '][DocuRefLine][' + drli + '][TypdeId]', item.typdeId);
      });
    });

    // Stampa il contenuto di FormData
    /*for (let pair of data.entries()) {
      console.log(`${pair[0]}: ${pair[1]}`);
    }*/
    return data;
  };


  const Placeorder = () => {
    modal.showLoading({
      title: t('popup.orderConfirmationAwaitingTitle'), 
      subtitle: t('popup.orderConfirmationAwaitingSubtitle'),
      allowOutsideClick: false,
    });

    let data;

    if (isSampleOrder) {
      data = buildSampleOrderBody();
    } else {
      data = buildStandardOrderBody();
    }

    axios
      .post(
        (isSampleOrder ? '/v1/order-sample-write-api?client_id=' : '/v1/order-write-api?client_id=') + dataUser.id,
        data,
        {
          headers: {
            Authorization: `Bearer ${dataUser?.token}`,
          },
        }
      )
      .then((response) => {
        // Funzione per estrarre ID ordine dal testo CDATA
        function extractOrderId(inputString) {
          const match = inputString.match(/the order ([A-Z0-9\-]+)/);
          return match ? match[1] : '';
        }

        
        const cdataText = response.data?.result?.data?.payload?.CDATA ?? '';

        // Estrai l'ID ordine
        const orderId = extractOrderId(cdataText);

        // Costruisci href
        let href =
          getTranslated(i18n, orderPlacedPaths, { en: 'en', it: 'it' }, 'it') +
          '?id=' +
          orderId;

        // SALVA NEL DATABASE SOLO SE È UN ORDINE DI CAMPIONATURA
        if (isSampleOrder && orderId) {

          href += '&type=sample';
          
          // Trova l'indirizzo di spedizione selezionato
          const selectedAddress = details?.addresses?.find(addr => addr.id === address);
          
          const orderData = {
            // Dati dell'ordine - REQUIRED
            order_id: orderId,
            client_id: parseInt(dataUser.id),
            customer_account: String(dataUser.ACCOUNTNUM || ''),
            
            // Dati del cliente - REQUIRED
            business_name: String(dataUser?.business_name || dataUser?.parent_name || ''),
            
            // Dati NULLABLE - invia solo se presenti
            ...(dataUser?.email && { email: String(dataUser.email) }),
            ...(dataUser?.mobile_no && { mobile_no: String(dataUser.mobile_no) }),
            ...(dataUser?.vat_number && { vat_number: String(dataUser.vat_number) }),
            ...(referent && { referent: String(referent) }),
            ...(notes && { notes: String(notes) }),
            
           
             order_date: new Date().toISOString().slice(0, 19).replace("T", " "),
            
            // Indirizzo di spedizione
            shipping_address: details?.addresses?.find(addr => addr.id === address),
            
            // Prodotti nel carrello
            cart_items: details?.carts?.map(item => ({
              product_id: item.id,
              product_type: item.product_type,
              quantity: item.quantity,
              config_id: item.config_id,
              color_id: item.color_id,
              is_available_json: item.is_available_json,
              product_price: item.product_price
            })),
            
            // Status - REQUIRED
            status: 'sent',
            
            // Dati aggiuntivi NULLABLE
            ...(referent && { sampling_customer_ref: String(referent) }),
            sampling_account_type: String(dataUser.ACCOUNTNUM || '').startsWith('PC') ? 'Prospect' : 'Customer',
            sampling_causal_code: 'WEB'
          };
          
          axios.post('/v1/order-sample-db-site', orderData, {
              headers: {
                Authorization: `Bearer ${dataUser?.token}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              }
            })
            .then((dbResponse) => {
              
              window.location.href = href; // redirect qui
            })
            .catch((dbError) => {
              console.error('Error saving sample order to database:', dbError);
              console.error('Error response:', dbError.response?.data);
              console.error('Validation errors:', dbError.response?.data?.errors);
              console.error('Status:', dbError.response?.status);
              // window.location.href = href; // commentato per vedere l'errore
            });

            return;
        }

        window.location.href = href;
      });

  };

  const Qtysum = (items, prop) => {
    return items.reduce(function (a, b) {
      return parseFloat(a) + parseFloat(b[prop]);
    }, 0);
  };

  const handleShipping = () => {
    Setshipping(0);
    axios
      .post('/v1/product_detail/get-shipping', {
        CURRENCYCODE: dataUser?.CURRENCY,
        WEIGHT: Qtysum(details?.carts, 'quantity'),
        ZONEID: FIL_LOGISTICSADDRESSZONEID || 1,
      })
      .then((res) => {
        const markupValue = res?.data?.result?.data?.payload?.data[0]?.MARKUPVALUE;
        Setshipping(parseFloat(markupValue || 0));
      });
  };



  const userDetail = () => {
    var formData = new FormData();
    formData.append('client_id', dataUser.ACCOUNTNUM);

    axios.post('/v1/product_detail/get-user-data', formData).then((res) => {
      const list = [...(res?.data?.result?.data?.payload?.data[0]?.UMIDITA || [])];

      const FILSalesWetnessPercent = list?.map((item, index) => {
        const randomNumber =
          Math.random() * (parseFloat(item.MAXWETNESSPERCENT) - parseFloat(item.MINWETNESSPERCENT)) +
          parseFloat(item.MINWETNESSPERCENT);
        return { id: index, randomNumber: randomNumber, qty: item.TOQTY };
      });
      setSpedizione_esente(res?.data?.result?.data?.payload?.data[0]?.DATI_SPEDIZIONE[0]?.FILTRANSPORTCHARGE);
      setUserShipCarrierAccount(res?.data?.result?.data?.payload?.data[0]?.SHIPCARRIERACCOUNT || '-');
      SetUser([...FILSalesWetnessPercent]);
    });
  };

  useEffect(() => {
    document.getElementById('home_page_class').classList.remove('home_page');
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    userDetail();
    list();
  }, []);

  const shippingMethods = (() => {
    let result = [];

    if (spedizione_esente == 'Sì') {
      result.push({
        pathForTranslatableTitle: 'Costo Spedizione esente',
        selectMe: () => {
          Setshipping(0);
          SetShipping_method(3);
          setShipCarrierAccount('');
          handleShipping();
        },
        isSelected: () => Shipping_method === 3,
      });
    }
    else {

      result.push({
        pathForTranslatableTitle: 'Spedizione tramite vettore Filmar',
        selectMe: () => {
          Setshipping(0);
          SetShipping_method(1);
          setShipCarrierAccount('');
          handleShipping();
        },
        isSelected: () => Shipping_method === 1,
      });
    }

    result.push({
      pathForTranslatableTitle: 'Ritiro tramite proprio vettore',
      selectMe: () => {
        SetShipping_method(2);
        Setshipping(0);
        setShipCarrierAccount(userShipCarrierAccount);
      },
      isSelected: () => Shipping_method === 2,
    });

    return result;
  })();

  const additionalIvaPrice = (totalForProducts + (Shipping_method === 3 ? 0 : shipping_) + totalSupplement) * User.getIvaAmount(dataUser);

  const ableToCheckout = useMemo(() => {
    if (!details || !details.carts?.length) {
      return false;
    }

    if (details.carts.every((item) => item.product_type === SAMPLE_PRODUCT_TYPE)) {
      return true;
    }

    return details.cartTotal > 0;
  }, [details, SAMPLE_PRODUCT_TYPE]);

  // Check if referent field is required (when in sample order) and if it's filled
  const isReferentRequired = isSampleOrder;
  const isReferentValid = referent && referent.trim().length > 0;
  const shouldShowReferentError = isReferentRequired && !isReferentValid && attemptedSubmitWithoutReferent;

  return (
    <>
      <div className="container checkout_page">
        <div>
          <h1 className="checkout_page_title">{t('Il tuo ordine')}</h1>
        </div>

        <div className="personal_data">
          <div className="checkout_section_title">
            <h2>{t('Dati personali')}</h2>
          </div>
          <div className="personal_data_content">
            <div className="personal_data_text">
              <p>{t('Ragione sociale')}</p>
              <h3>{dataUser?.business_name || dataUser?.parent_name}</h3>
            </div>
            <div className="personal_data_text">
              <p>{t('P.IVA')}</p>
              <h3>{dataUser?.vat_number}</h3>
            </div>
            <div className="personal_data_text">
              <p>{t('Email')}</p>
              <h3>{dataUser?.email}</h3>
            </div>
            <div className="personal_data_text">
              <p>{t('Telefono')}</p>
              <h3>{dataUser?.mobile_no}</h3>
            </div>
            {/* <div className="personal_data_text">
              <p>{t('Email')}</p>
              <h3>{dataUser?.email}</h3>
            </div>
            <div className="personal_data_text">
              <p>{t('Telefono')}</p>
              <h3>{dataUser?.mobile_no}</h3>
            </div> */}
          </div>
        </div>
        {detailsLoader.asJsx || (
          <>
            <div className="shipping_address checkout_section">
              <div className="checkout_section_title">
                <h2>{t('Indirizzo di spedizione')}</h2>
              </div>
              <div className="checkout_section_content">
                {details?.addresses?.map((item, index, items) => {
                  let selectThisItem = () => {
                    Setaddress(item.id);
                    SetFIL_LOGISTICSADDRESSZONEID(item.FIL_LOGISTICSADDRESSZONEID);
                  };
                  let isSingleItem = items.length === 1;

                  if (isSingleItem && address !== item.id) selectThisItem();

                  if (!address && item.ISPRIMARY === 'Sì') selectThisItem();

                  return (
                    <div className={`options_text ${address === item.id ? 'active' : ''}`} key={index}>
                      {!isSingleItem && (
                        <label>
                          <input
                            type="radio"
                            name="shippingAddress"
                            onClick={(e) => {
                              Setaddress(item.id);
                              SetFIL_LOGISTICSADDRESSZONEID(item.FIL_LOGISTICSADDRESSZONEID);
                            }}
                            defaultChecked={address === item.id}
                          />
                          <span className="checkbox" />
                        </label>
                      )}
                      <div>
                        <h3> {item.ADDRESSNAME}</h3>
                        <p>{item.ADDRESS}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            {!isSampleOrder ? (
              <>
                <div className="shipping_options checkout_section">
                  <div className="checkout_section_title">
                    <h2>{t('Opzioni di spedizione')}</h2>
                  </div>
                  {availableShippingOptionList.map((item, index, items) => {
                    let selectThisItem = () => Setshipping_option(item.type);

                    let isSingleItem = items.length === 1;

                    if (isSingleItem && shipping_option !== item.type) selectThisItem();

                    return (
                      <div className="checkout_section_content">
                        <div className={`options_text ${shipping_option == item.type ? 'active' : ''}`}>
                          {!isSingleItem && (
                            <label>
                              <input
                                type="radio"
                                name="shippingOption"
                                onClick={selectThisItem}
                                checked={shipping_option === item.type}
                              />
                              <span className="checkbox" />
                            </label>
                          )}
                          <div>
                            <h3>{t(item.type === 'single' ? 'Spedizione unica' : 'Spedizione parziale')}</h3>
                            {/* <p>10 articoli - data di consegna 30/10/2022</p> */}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="shipping_method checkout_section">
                  <div className="checkout_section_title">
                    <h2>{t('Metodo di spedizione')}</h2>
                  </div>
                  <div className="checkout_section_content">
                    {shippingMethods.map((item, index, items) => {
                      let isSingleItem = items.length === 1;

                      if (isSingleItem && !item.isSelected()) item.selectMe();

                      return (
                        <div className={`options_text ${item.isSelected() ? 'active' : ''}`}>
                          {!isSingleItem && (
                            <label>
                              <input type="radio" name="Metodo" checked={item.isSelected()} onClick={item.selectMe} />
                              <span className="checkbox" />
                            </label>
                          )}
                          <div>
                            <h3>{t(item.pathForTranslatableTitle)}</h3>
                            {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod</p> */}
                          </div>
                        </div>
                      );
                    })}
                    {/* {FIL_LOGISTICSADDRESSZONEID != 0 ? (
                  <div className={`options_text ${Shipping_method == 1 ? 'active' : ''}`}>
                    <label>
                      <input
                        type="radio"
                        name="Metodo"
                        onClick={(e) => {
                          Setshipping(0);
                          SetShipping_method(1);
                          handleShipping();
                        }}
                      />
                      <span className="checkbox" />
                    </label>
                    <div>
                      <h3>{t('Spedizione tramite vettore Filmar')}</h3>
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod</p>
                    </div>
                  </div>
                ) : (
                  ''
                )} */}
                    {/* {dataUser?.BFCARRIERNAME ? (
                  ''
                ) : (
                  <div className={`options_text ${true ? 'active' : ''}`}>
                    <label>
                      <input
                        type="radio"
                        name="Metodo"
                        onClick={(e) => {
                          SetShipping_method(2);
                        }}
                      />
                      <span className="checkbox" />
                    </label>
                    <div>
                      <h3>{t('Ritiro tramite proprio vettore')}</h3>
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod</p>
                    </div>
                  </div>
                )} */}
                  </div>
                </div>
                <div className="payment_method checkout_section">
                  <div className="checkout_section_title">
                    <h2>{t('Metodo pagamento')}</h2>
                  </div>
                  {[1].map((item, index, items) => {
                    let selectThisItem = () => SetPayment_method(1);

                    let isSingleItem = items.length === 1;

                    if (isSingleItem && Payment_method !== item) selectThisItem();

                    return (
                      <div className="checkout_section_content">
                        <div className={`options_text ${Payment_method == item ? 'active' : ''}`}>
                          {!isSingleItem && (
                            <label>
                              <input type="radio" name="Payment_method" onClick={selectThisItem} />
                              <span className="checkbox" />
                            </label>
                          )}
                          <div>
                            <h3>
                              {getTranslated(i18n, payment, { en: 'name_en', it: 'name_it ' }, 'name_it')} -{' '}
                              {getTranslated(i18n, paymentTerm, { en: 'name_en', it: 'name_it ' }, 'name_it')}
                            </h3>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            ) : null}
            <div className="articles_section">
              <div className="articles_section_title">
                <h4>{t('Articoli')}</h4>
              </div>
              <div>
                {details?.carts?.map((item, index) => {
                  // Controlla se è un book: product_type sample il cui codice_sample corrisponde a un book.item_id
                  const sample = JSON.parse(item.is_available_json || '{}')?.sample;
                  const isBook = item.product_type === SAMPLE_PRODUCT_TYPE && 
                                 sample?.codice_sample &&
                                 books.some(b => b.item_id === sample.codice_sample);
                  
                  if (isBook) {
                    return <PBook item={item} withBorderBottom books={books} />;
                  } else if (item.product_type === SAMPLE_PRODUCT_TYPE) {
                    return <PSample item={item} withBorderBottom />;
                  } else {
                    return <CheckoutPurchase item={item} />;
                  }
                })}
              </div>
            </div>
            <div className="checkout_bottom_section">
              <div className="order_note">
                {isSampleOrder ? (
                  <>
                    <div className="checkout_section_title">
                      <h2>{t('Referente')}*</h2>
                    </div>
                    <div className="referent">
                      <input
                        className="text"
                        name="referent"
                        placeholder={t('Inserire un nominativo...')}
                        value={referent}
                        onChange={(e) => {
                          setReferent(e.target.value);
                        }}
                        type="text"
                        required
                        style={shouldShowReferentError ? {
                          borderColor: '#dc3545',
                          borderWidth: '2px'
                        } : {}}
                      />
                      {shouldShowReferentError && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#dc3545', fontSize: '13px', marginTop: '6px' }}>
                          <span>{t('register.field_required')}</span>
                        </div>
                      )}
                    </div>
                  </>
                ) : null}
                <div className="checkout_section_title">
                  <h2>{t('Nota ordine')}</h2>
                  <p>{t("Aggiungi una nota d'ordine")}</p>
                </div>
                <div>
                  <form action>
                    <textarea
                      onChange={(e) => {
                        Setnote(e.target.value);
                      }}
                      name
                      id
                      placeholder={t('common.inserisci_il_tuo')}
                      defaultValue={''}
                    />
                  </form>
                </div>
              </div>
              {ableToCheckout ? (
                <div className="order_summary_section">
                  {!isSampleOrder ? (
                    <>
                      <div className="order_summary_section_title">
                        <h4>{t('Riepilogo ordine')}</h4>
                      </div>
                      <div className="order_summary_details">
                        <div className="order_summary_details_text">
                          <p>{t('Totale articoli')}</p>
                          <p>{formatPriceForView(totalForProducts)}</p>
                        </div>
                        {!!totalSupplement && (
                          <div className="order_summary_details_text">
                            <p>{t('Supplemento')}</p>
                            <p>{formatPriceForView(totalSupplement)}</p>
                          </div>
                        )}
                        <div className="order_summary_details_text">
                          <p>{t('Sub-totale')}</p>
                          <p>{formatPriceForView(totalForProducts + (totalSupplement ?? 0))}</p>
                        </div>
                        {Shipping_method === 1 && (
                          <div className="order_summary_details_text">
                            <p>{t('Spese di spedizione')}</p>
                            <p>{formatPriceForView(shipping_)}</p>
                          </div>
                        )}
                        {!!additionalIvaPrice && (
                          <div className="order_summary_details_text">
                            <p>Iva 22%</p>
                            <p>{formatPriceForView(additionalIvaPrice)}</p>
                          </div>
                        )}
                        <div className="order_total">
                          <p>{t('Totale')}</p>
                          <p>{formatPriceForView(totalForProducts + + (totalSupplement ?? 0) + (Shipping_method === 3 ? 0 : shipping_) + (additionalIvaPrice ?? 0))}</p>
                        </div>
                      </div>
                    </>
                  ) : null}
                  <div className="order_proceed">
                    <Link className="back_cart_btn" to={getTranslated(i18n, cartPaths, { en: 'en', it: 'it' }, 'it')}>
                      {t('Torna al carrello')}
                    </Link>
                    {(Shipping_method !== 0 || isSampleOrder) && !(!isReferentValid && isReferentRequired) ? (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          Placeorder();
                        }}
                        className="conform_order_btn"
                      >
                        {t('Conferma ordine')}{' '}
                      </a>
                    ) : (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          if (!isReferentValid && isReferentRequired) {
                            setAttemptedSubmitWithoutReferent(true);
                          }
                        }}
                        className="conform_order_btn"
                        style={{ cursor: 'default', opacity: 0.5 }}
                        title={!isReferentValid && isReferentRequired ? t('Compila il campo referente per continuare') : ''}
                      >
                        {t('Conferma ordine')}
                      </a>
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Checkout;